export interface Css {
    text: string;
}

export const initialCss: Readonly<Css> = {
    text: null,
};
